export default "__VITE_ASSET__24790317__"